import { FiLock, FiMail } from 'react-icons/fi';
import { AuthShell } from '../_Shared/AuthShell';
import { useAuthLogin } from '../../_Hooks/useAuthLogin';
import { AppSeo } from '../../../../../../_CORE/APP/Templates/_UI/Seo/_index';
import { AppButton } from '../../../../../../_CORE/APP/Templates/_UI/Button/_index';
import { FieldInput } from '../../../../../../_CORE/APP/Templates/_UI/Form/_index';
import { onLoginContent } from '../../_Resources/Content/Login.Resources';
import { onFieldsContent } from '../../_Resources/Content/Fields.Resources';
import { useLanguage } from '../../../../../../_CORE/APP/Hooks/Contexts/Translate/useLanguageContext';

export const AuthLoginViewMain = () => {
    const { useDataLanguage } = useLanguage();
    const CONTENT = onLoginContent(useDataLanguage.currentLang);
    const FIELDS = onFieldsContent(useDataLanguage.currentLang);
    const { FORM, isLoading } = useAuthLogin();

    return (
        <>
            <AppSeo title={CONTENT.SEO_TITLE} description={CONTENT.SEO_DESCRIPTION} />
            <AuthShell>
                <div className="PBAUTH__card PBAUTH__card--login">
                    <h1 className="PBAUTH__card_title">{CONTENT.CARD_TITLE}</h1>

                    <form className="PBAUTH__form" onSubmit={FORM.onSubmit} autoComplete="off" noValidate>
                        <FieldInput {...FORM.field('email')} type="email" span={2}
                            label={FIELDS.EMAIL_LABEL} placeholder={FIELDS.EMAIL_PLACEHOLDER}
                            iconStart={<FiMail />} isDisabled={isLoading} />

                        <FieldInput {...FORM.field('password')} type="password" span={2}
                            label={FIELDS.PASSWORD_LABEL} placeholder={FIELDS.PASSWORD_PLACEHOLDER}
                            iconStart={<FiLock />} isDisabled={isLoading} />

                        <div className="PBAUTH__submit_row">
                            <AppButton className="PBAUTH__submit" type="submit" size="lg" isLoading={isLoading}>
                                {isLoading ? CONTENT.SUBMIT_LOADING : CONTENT.SUBMIT}
                            </AppButton>
                        </div>
                    </form>
                </div>
            </AuthShell>
        </>
    );
};
